import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css'; // optional for styling
import 'tippy.js/themes/light.css'; // optional for styling

const $ = jQuery;

$( () => {

    tippy('.tooltip-benefit', {
        allowHTML: true,
        placement: 'top',
        maxWidth: 450,
        offset: [0, 20],
        /* zIndex: 10, */
        interactive: true,

        content(reference) {
            return reference.getElementsByClassName('tooltip-content')[0].innerHTML;
        }, 
    });

} );